import React, { useEffect, useState } from 'react';
import axios from 'axios';

function Home() {
    const [items, setItems] = useState([]);
    const [quotationData, setQuotationData] = useState({ calculationBy: 'SqFt' }); // Example for quotationData

    const apiUrl = 'http://192.168.1.39/api/'; // Replace with your API URL

    // Fetch data from the API when the component mounts
    useEffect(() => {
        const fetchItems = async () => {
            try {
                const token = localStorage.getItem("api_token");
                const response = await axios.get(`${apiUrl}/admin/getAllItems`, {
                    headers: {
                        api_token: token,
                    },
                });
                setItems(response.data); // Assuming the API response matches the structure
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };

        fetchItems(); // Trigger the fetch function
    }, []);

    // Handle input changes in the table
    const handleItemChange = (index, field, value) => {
        const updatedItems = [...items];
        updatedItems[index][field] = value;
        setItems(updatedItems); // Update the state with the new value
        saveItemChange(updatedItems[index]); // Send updated item to backend
    };

    // Save the updated item back to the backend
    const saveItemChange = async (updatedItem) => {
        try {
            const token = localStorage.getItem("api_token");
            const response = await axios.put(`${apiUrl}/admin/updateItem/${updatedItem.id}`, updatedItem, {
                headers: {
                    api_token: token,
                },
            });
            console.log('Item updated successfully:', response.data);
        } catch (error) {
            console.error('Error updating item:', error);
        }
    };

    // Handle key down events (optional for navigation or other behavior)
    const handleKeyDown = (index, fieldNumber, event) => {
        if (event.key === 'Enter') {
            console.log(`Enter pressed on field ${fieldNumber} for item ${index + 1}`);
        }
    };

    return (
        <div>
            <table className="w-full border-collapse border border-gray-300 mb-4 mt-5 rounded-lg">
                <thead className="bg-gray-200">
                    <tr>
                        <th className="border border-gray-300 p-3 text-center">Sr No</th>
                        <th className="border border-gray-300 p-3 text-center">Gr No</th>
                        <th className="border border-gray-300 p-3 text-center">Code</th>
                        <th className="border border-gray-300 p-3 text-center">Name</th>
                        <th className="border border-gray-300 p-3 text-center">Length</th>
                        <th className="border border-gray-300 p-3 text-center">X</th>
                        <th className="border border-gray-300 p-3 text-center">Width</th>
                        <th className="border border-gray-300 p-3 text-center">Cal</th>
                        <th className="border border-gray-300 p-3 text-center">Quantity</th>
                        <th className="border border-gray-300 p-3 text-center">SquareFeet</th>
                        <th className="border border-gray-300 p-3 text-center">Rate</th>
                        <th className="border border-gray-300 p-3 text-center">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td className="border border-gray-300 p-3">{index + 1}</td>
                            <td className="border border-gray-300 p-3">{item.grNo}</td>
                            <td className="border border-gray-300 p-3">
                                <input
                                    type="text"
                                    value={item.code}
                                    onChange={(e) => handleItemChange(index, 'code', e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(index, 1, e)}
                                    className="border border-gray-300 p-2 rounded-md w-full"
                                />
                            </td>
                            <td className="border border-gray-300 p-3">{item.name}</td>
                            <td className="border border-gray-300 p-3">
                                <input
                                    type="number"
                                    value={item.length}
                                    onChange={(e) => handleItemChange(index, 'length', parseFloat(e.target.value) || 0)}
                                    onKeyDown={(e) => handleKeyDown(index, 3, e)}
                                    className="border border-gray-300 p-2 rounded-md w-full"
                                />
                            </td>
                            <td className="border border-gray-300 p-3 text-center">X</td>
                            <td className="border border-gray-300 p-3">
                                <input
                                    type="number"
                                    value={item.width}
                                    onChange={(e) => handleItemChange(index, 'width', parseFloat(e.target.value) || 0)}
                                    onKeyDown={(e) => handleKeyDown(index, 5, e)}
                                    className="border border-gray-300 p-2 rounded-md w-full"
                                />
                            </td>
                            <td className="border border-gray-300 p-3 text-center">{quotationData.calculationBy}</td>
                            <td className="border border-gray-300 p-3">
                                <input
                                    type="number"
                                    value={item.quantity}
                                    onChange={(e) => handleItemChange(index, 'quantity', parseFloat(e.target.value) || 0)}
                                    onKeyDown={(e) => handleKeyDown(index, 7, e)}
                                    className="border border-gray-300 p-2 rounded-md w-full"
                                />
                            </td>
                            <td className="border border-gray-300 p-3">{item.squareFeet}</td>
                            <td className="border border-gray-300 p-3">
                                <input
                                    type="number"
                                    value={item.rate}
                                    onChange={(e) => handleItemChange(index, 'rate', parseFloat(e.target.value) || 0)}
                                    onKeyDown={(e) => handleKeyDown(index, 9, e)}
                                    className="border border-gray-300 p-2 rounded-md w-full"
                                />
                            </td>
                            <td className="border border-gray-300 p-3">
                                <input
                                    type="number"
                                    value={item.amount}
                                    onChange={(e) => handleItemChange(index, 'amount', parseFloat(e.target.value) || 0)}
                                    onKeyDown={(e) => handleKeyDown(index, 10, e)}
                                    className="border border-gray-300 p-2 rounded-md w-full"
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Home;
